import Rating from '@material-ui/lab/Rating';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { capitalizeFirstLetter } from '@utils/Util';

const AddReview = ({ viewType, onCloseReview, onSuccess, supplierDetails, selectedData }) => {
	const [selectedItem, setSelecteItem] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [errors, setErrors] = useState(null);

	useEffect(() => {
		if (viewType === 'edit') {
			setSelecteItem(selectedData);
		}
	}, [selectedData]);

	const handleClose = () => {
		setSelecteItem(null);
		onCloseReview();
	};

	const checkIsValidReview = (body) => {
		let { communicationRatingValue, onTimeDeliveryRatingValue, experienceRatingValue } = body;
		let newErrors = {};
		if (communicationRatingValue === 0) {
			newErrors = { ...newErrors, comError: 'Communication is required' };
		}
		if (onTimeDeliveryRatingValue === 0) {
			newErrors = { ...newErrors, supportError: 'Transparency is required' };
		}
		if (experienceRatingValue === 0) {
			newErrors = { ...newErrors, expError: 'Support is required' };
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const updateReview = async (body) => {
		await ApiClient.PUT('updateReview', { ...body }, selectedItem.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					onSuccess();
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const addReview = async () => {
		setIsLoading(true);
		let body = {
			communicationRatingValue: selectedItem?.communicationRatingValue || 0,
			onTimeDeliveryRatingValue: selectedItem?.onTimeDeliveryRatingValue || 0,
			experienceRatingValue: selectedItem?.experienceRatingValue || 0,
			remarks: selectedItem?.remarks || ''
		};

		let valid = checkIsValidReview(body);
		if (!valid) {
			setIsLoading(false);
			return;
		}
		if (viewType === 'edit') updateReview(body);
		else {
			await ApiClient.POST('addReview', { ...body }, supplierDetails?.supplierId)
				.then(({ data }) => {
					setIsLoading(false);
					if (data && data.success) {
						toastSuccess(data.message);
						onSuccess();
						handleClose();
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		}
	};

	const onRemove = async () => {
		setIsLoading(true);
		await ApiClient.DELETE('deleteSupplierReview', {}, selectedItem.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					onSuccess();
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				handleClose();
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const RatingSection = ({ label, ratingName = 0, ratingValue, onChange }) => {
		return (
			<div className="info-details d-flex align-items-center justify-content-between">
				<p className="regular-14">{label}</p>
				<p className="gray_dark_02">:</p>
				<p className="regular-14">
					<Rating name={ratingName} value={ratingValue || 0} onChange={onChange} />
				</p>
			</div>
		);
	};

	return (
		<Modal show={true} onHide={handleClose} centered className="auto-width-popup" backdrop="static">
			<div className="common-popup add-profile-rating-popup add-profile-rating-popup-v2">
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">
								Feedback - {capitalizeFirstLetter(supplierDetails?.supplierName)}{' '}
							</h3>
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								<div className="col-md-12">
									<h3 className="semibold-16 mb-0 pb-2">{selectedItem?.supplierName}</h3>
									<div className="all-review-details">
										<RatingSection
											label="Communication *"
											ratingName="communicationRatingValue"
											ratingValue={selectedItem?.communicationRatingValue}
											onChange={(event, newValue) => {
												setSelecteItem({
													...selectedItem,
													communicationRatingValue: newValue
												});
											}}
										/>
										{errors?.comError && <p className="error">{errors.comError}</p>}

										<RatingSection
											label="Support *"
											ratingName="experienceRatingValue"
											ratingValue={selectedItem?.experienceRatingValue}
											onChange={(event, newValue) => {
												setSelecteItem({
													...selectedItem,
													experienceRatingValue: newValue
												});
											}}
										/>

										{errors?.expError && <p className="error">{errors.expError}</p>}

										<RatingSection
											label="Transparency *"
											ratingName="onTimeDeliveryRatingValue"
											ratingValue={selectedItem?.onTimeDeliveryRatingValue}
											onChange={(event, newValue) => {
												setSelecteItem({
													...selectedItem,
													onTimeDeliveryRatingValue: newValue
												});
											}}
										/>
										{errors?.supportError && (
											<p className="error">{errors.supportError}</p>
										)}
									</div>
									<div className="form-group mb-0">
										<label htmlFor="review">Write review</label>
										<textarea
											name="review"
											id="review"
											placeholder="Write remarks"
											value={selectedItem?.remarks}
											onChange={(e) =>
												setSelecteItem({
													...selectedItem,
													remarks: e.target.value
												})
											}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div
						className={`common-popup-footer d-flex ${
							viewType === 'edit' ? 'justify-content-between' : 'justify-content-end'
						}`}
					>
						{viewType === 'edit' && (
							<div className="delete-btn">
								<button
									disabled={isLoading}
									className="button text size32"
									onClick={onRemove}
								>
									Delete
								</button>
							</div>
						)}
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={handleClose}>
								Cancel
							</button>
							<button className="button size32 ml-2" disabled={isLoading} onClick={addReview}>
								Submit
							</button>
						</div>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default AddReview;
